<template>
  <div class="mango-h5">
    <img
      class="bg"
      src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/c071b4f01a5fe5a9e96bcf61c909a239_wh=1500_3248.png"
      alt=""
    />
    <div class="login-container">
      <MyLogin @login="bindLogin" />
    </div>
  </div>
</template>

<script>
import MyLogin from './components/login.vue'
export default {
  components: { MyLogin },
  data() {
    return {}
  },
  created() {},
  methods: {
    async bindLogin(params) {
      this.$toast.loading()
      let res = await this.$http
        .postApp('api/v1/RegisterUser/registerForMgTv', params)
        .catch(() => {})
      this.$toast.clear()
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$dialog
            .alert({
              title: '提示',
              message: '绑定成功，请联系营养师助理领取优惠~'
            })
            .then(() => {
              // on close
            })
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.mango-h5 {
  min-height: 100vh;
  background-color: rgb(143, 189, 255);
  position: relative;
  z-index: 0;
  overflow: hidden;
  .bg {
    position: absolute;
    left: 0;
    top: -55px;
    width: 100%;
    z-index: -1;
  }
  .login-container {
    margin-top: 490px;
    margin-bottom: 60px;
    padding: 0px 20px;
  }
}
</style>
